export const parseIndex = (str) => {
    const reg = /\b(?:10[.][0-9]{4,}(?:[.][0-9]+)*\/(?:(?!["&'<>])\S)+)\b/gi;
    const indexes = [];
    let res = reg.exec(str);
    while (res !== null) {
        indexes.push(res.index, res.index + res[0].length);
        res = reg.exec(str);
    }
    return indexes;
}

export const isDoi = (str) => {
    return /\b(?:10[.][0-9]{4,}(?:[.][0-9]+)*\/(?:(?!["&'<>])\S)+)\b/i.test(str);
};



// WEBPACK FOOTER //
// ./src/services/doiParser.js